import { render } from "./SelectList.vue?vue&type=template&id=2288e857&scoped=true"
import script from "./SelectList.vue?vue&type=script&lang=js"
export * from "./SelectList.vue?vue&type=script&lang=js"

import "./SelectList.vue?vue&type=style&index=0&id=2288e857&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-2288e857"

export default script